// extracted by mini-css-extract-plugin
export var cartContainer = "_qr-4";
export var gray = "_qr-1";
export var itemContainer = "_qr-2";
export var itemDetails = "_qr-3";
export var strong = "_qr-0";